import { reportAppError } from '@shared/reportAppError';
import { flushGuestPricingImpressionsForRestaurant } from './guestPricingImpressionQueue';
import { postGuestPricingConversion } from './guestPricingApiHelpers';
import { getOrCreateGuestPricingSessionId } from './guestPricingSessionId';

export const enqueueGuestReservationPricingConversion = ({
  restaurantId,
  reservationId,
}: {
  restaurantId: string;
  reservationId: string;
}): void => {
  void (async () => {
    await flushGuestPricingImpressionsForRestaurant(restaurantId);
    try {
      await postGuestPricingConversion({
        restaurantId,
        sessionId: getOrCreateGuestPricingSessionId(restaurantId),
        clientTimestamp: new Date().toISOString(),
        reservationId,
      });
    } catch (error: unknown) {
      reportAppError(error);
    }
  })();
};

export const enqueueGuestOfferPricingConversion = ({
  restaurantId,
  offerId,
}: {
  restaurantId: string;
  offerId: string;
}): void => {
  void (async () => {
    await flushGuestPricingImpressionsForRestaurant(restaurantId);
    try {
      await postGuestPricingConversion({
        restaurantId,
        sessionId: getOrCreateGuestPricingSessionId(restaurantId),
        clientTimestamp: new Date().toISOString(),
        offerId,
      });
    } catch (error: unknown) {
      reportAppError(error);
    }
  })();
};
